import supportsPerformanceAPI from './supportsPerformanceAPI';

/**
 * Returns the baseline mark to use for measurements.
 *
 * On initial load, this baseline will not exist so measurements will run against the 0 second.
 * On route changes, this baseline will represent the moment the route has changed.
 */
export default (): PerformanceMark | undefined => {
  if (!supportsPerformanceAPI()) {
    return undefined;
  }

  return performance.getEntriesByName('baseline')[0] as PerformanceMark;
};
